import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const firmSubTypeColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'firmSubType',
  headerName: 'Firm Subtype',
  initialHide: true,
};
